<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">

      <h1 class="titulo m-t-2 m-t-3-md">Balance nacional de energía eléctrica</h1>

      <hr/>
      
      <p class="texto-primario">El Balance Nacional de Energía eléctrica integra información estadística sobre la producción eléctrica, importaciones, exportaciones y por otro lado la demanda de la electricidad por sectores en un año determinado. Tiene por objeto analizar el desempeño del sector eléctrico para el diseño de políticas públicas y para la toma de decisiones. </p>
    
    </div>
    <div class="container">
      <div class="tarjeta-contenedor">
      <div class="encabezado">
        <h3>Integración de la generación y uso final de la electricidad</h3>
        <p class="texto-notas">Datos en TWh. Año: 2019.</p>
      </div>
      <div class="contenido">
        <div class="graficaFlujo" ref="graficaFlujo">
        </div>
      </div>
      <div class="tarjeta-contendor-notas">
        <p class="texto-notas">Datos elaborados a partir del Balance Nacional de Energía: Electricidad del SIE.</p>
      </div>
    </div>

    <br>


      <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Producción eléctrica anual, importación y exportación</h3>
            <p class="texto-notas">Datos en TWh.</p>
          </div>
          <div class="contenido">
            <div class="barrasProd" ref="barrasProd">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas">Datos elaborados a partir del Balance Nacional de Energía: Electricidad del SIE.</p>
              <p class="texto-notas">Notas:1) La producción no incluye autogeneración de energía eléctrica. 2) El consumo propio del sector incluye autoconsumo por generación y transmisión. 3) La diferencia estadística equivale a los excedentes de autogeneradores de energía eléctrica. 4) A partir de 2016 se incluye información de las centrales eléctricas con permiso de generación otorgado por la CRE.</p>
          </div>
      </div>

    <br>
 

    <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Demanda eléctrica anual</h3>
            <p class="texto-notas">Datos en TWh.</p>
          </div>
          <div class="contenido">
            <div class="barrasDamandaElectrica" ref="barrasDamandaElectrica">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas">Datos elaborados a partir del Balance Nacional de Energía: Electricidad del SIE.</p>
              <p class="texto-notas">Notas:1) La producción no incluye autogeneración de energía eléctrica. 2) El consumo propio del sector incluye autoconsumo por generación y transmisión. 3) La diferencia estadística equivale a los excedentes de autogeneradores de energía eléctrica. 4) A partir de 2016 se incluye información de las centrales eléctricas con permiso de generación otorgado por la CRE.</p>
          </div>
      </div>


    <br>
   

    <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Demanda eléctrica anual del sector industrial</h3>
            <p class="texto-notas">Datos en TWh.</p>
          </div>
          <div class="contenido">
            <div class="barrasIndustria" ref="barrasIndustria">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas">Datos elaborados a partir del Balance Nacional de Energía: Electricidad del SIE.</p>
              <p class="texto-notas">Notas:1) La producción no incluye autogeneración de energía eléctrica. 2) El consumo propio del sector incluye autoconsumo por generación y transmisión. 3) La diferencia estadística equivale a los excedentes de autogeneradores de energía eléctrica. 4) A partir de 2016 se incluye información de las centrales eléctricas con permiso de generación otorgado por la CRE.</p>
          </div>
      </div>

    <br>

      
    <div class="tarjeta-contenedor">
      <div class="encabezado">
        <h3>Uso final de la electricidad</h3>
        <p class="texto-notas">Datos en TWh. Año: 2019.</p>
      </div>
      <div class="contenido">
        <div class="graficaFlujoConsumo" ref="graficaFlujoConsumo">
        </div>
      </div>
      <div class="tarjeta-contendor-notas">
        <p class="texto-notas">Datos elaborados a partir del Balance Nacional de Energía: Electricidad del SIE.</p>
      </div>
    </div>

    

    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
          <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
          <ul class="lista-referencias">
            <li><em><strong>Sistema de Información Energética (SIE) (2023).</strong></em> Balance Nacional de Energía: Electricidad. <a href="https://sie.energia.gob.mx/bdiController.do?action=cuadro&cvecua=E323" target="_blank">https://sie.energia.gob.mx/bdiController.do?action=cuadro&cvecua=E323</a></li>
            <li><em><strong>Sistema de Información Energética (SIE) (2023).</strong></em> Sistema de Información Energética (SIE), 2023. Balance Nacional de Energía: Energía secundaria. <a href="https://sie.energia.gob.mx/bdiController.do?action=cuadro&cvecua=E326" target="_blank">https://sie.energia.gob.mx/bdiController.do?action=cuadro&cvecua=E326</a></li>
          </ul>
    </div>

  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";
am4core.useTheme(am4themes_kelly);

export default {
  name: 'App',
  components: {
  },
  mounted() {

      //Gráfica: Producción eléctrica anual, importación y exportación
      let chartProd = am4core.create(this.$refs.barrasProd, am4charts.XYChart);
      chartProd.language.locale = am4lang_es_ES;
      chartProd.language.locale["_decimalSeparator"] = ".";
      chartProd.language.locale["_thousandSeparator"] = ",";
      chartProd.exporting.menu = new am4core.ExportMenu();
      chartProd.exporting.filePrefix = "ProduccionElectricaAnualImportacionExportacion";
      chartProd.exporting.useWebFonts = false;
      chartProd.maskBullets = false;
      chartProd.paddingLeft = 20;
      chartProd.paddingRight = 50;
      chartProd.fontSize = 12;

      chartProd.data = prodDatos;

      // Create axes
      let categoryAxis3 = chartProd.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis3.dataFields.category = "a";
      categoryAxis3.renderer.grid.template.location = 0;
      categoryAxis3.renderer.minGridDistance = 10;

      let valueAxis3 = chartProd.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis3.title.text = "TWh";
      valueAxis3.min = 0;
      valueAxis3.extraMax = 0.1;
      valueAxis3.calculateTotals = true;

      // Create series
      function createSeries3(field, name, color) {
        
        // Set up series
        let series = chartProd.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        

        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

        return series;
      }

      for(var i=0; i<prodVariables.length; i++)
      {
        let v = prodVariables[i];
        createSeries3(v.id, v.nombre,v.color);
      }


      var totalSeriesProd = chartProd.series.push(new am4charts.ColumnSeries());
      totalSeriesProd.dataFields.valueY = "total";
      totalSeriesProd.dataFields.categoryX = "a";
      totalSeriesProd.stacked = true;
      totalSeriesProd.hiddenInLegend = true;
      totalSeriesProd.columns.template.strokeOpacity = 0;

      var totalBulletProd = totalSeriesProd.bullets.push(new am4charts.LabelBullet());
      totalBulletProd.dy = -10;
      totalBulletProd.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletProd.label.hideOversized = false;
      totalBulletProd.label.fontSize = 10;
      totalBulletProd.label.fill = am4core.color("#333");
      totalBulletProd.label.background.fillOpacity = 0.2;
      totalBulletProd.label.padding(5, 5, 5, 5);

      // Legend
      chartProd.legend = new am4charts.Legend();
      chartProd.legend.useDefaultMarker = true;
      let marker3 = chartProd.legend.markers.template.children.getIndex(0);
      marker3.cornerRadius(12, 12, 12, 12);
      marker3.strokeWidth = 2;
      marker3.strokeOpacity = 1;
      marker3.stroke = am4core.color("#fff");

      this.chartProd = chartProd;

      //Gráfica: Demanda eléctrica anual
      let chart4 = am4core.create(this.$refs.barrasDamandaElectrica, am4charts.XYChart);
      chart4.language.locale = am4lang_es_ES;
      chart4.language.locale["_decimalSeparator"] = ".";
      chart4.language.locale["_thousandSeparator"] = ",";
      chart4.exporting.menu = new am4core.ExportMenu();
      chart4.exporting.filePrefix = "DemandaElectricaAnual";
      chart4.exporting.useWebFonts = false;
      chart4.paddingLeft = 20;
      chart4.paddingRight = 50;
      chart4.fontSize = 12;

      chart4.data = demandaDatos;

      // Create axes
      let categoryAxis4 = chart4.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis4.dataFields.category = "a";
      categoryAxis4.renderer.grid.template.location = 0;
      categoryAxis4.renderer.minGridDistance = 10;


      let valueAxis4 = chart4.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis4.title.text = "TWh";
      valueAxis4.min = 0;
      valueAxis4.extraMax = 0.1;
      valueAxis4.calculateTotals = true;

      // Create series
      function createSeries4(field, name, color) {
        
        // Set up series
        let series = chart4.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        
        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
        
        return series;
      }

      for(var i=0; i<demandaVariables.length; i++)
      {
        let v = demandaVariables[i];
        createSeries4(v.id, v.nombre,v.color);
      }

      var totalSeriesDemanda = chart4.series.push(new am4charts.ColumnSeries());
      totalSeriesDemanda.dataFields.valueY = "total";
      totalSeriesDemanda.dataFields.categoryX = "a";
      totalSeriesDemanda.stacked = true;
      totalSeriesDemanda.hiddenInLegend = true;
      totalSeriesDemanda.columns.template.strokeOpacity = 0;

      var totalBulletDemanda = totalSeriesDemanda.bullets.push(new am4charts.LabelBullet());
      totalBulletDemanda.dy = -10;
      totalBulletDemanda.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletDemanda.label.hideOversized = false;
      totalBulletDemanda.label.fontSize = 10;
      totalBulletDemanda.label.fill = am4core.color("#333");
      totalBulletDemanda.label.background.fillOpacity = 0.2;
      totalBulletDemanda.label.padding(5, 5, 5, 5);

      // Legend
      chart4.legend = new am4charts.Legend();
      chart4.legend.useDefaultMarker = true;
      let marker4 = chart4.legend.markers.template.children.getIndex(0);
      marker4.cornerRadius(12, 12, 12, 12);
      marker4.strokeWidth = 2;
      marker4.strokeOpacity = 1;
      marker3.stroke = am4core.color("#fff");

      this.chart4 = chart4;

      //Gráfica: Demanda eléctrica anual del sector industrial
      let chart5 = am4core.create(this.$refs.barrasIndustria, am4charts.XYChart);
      chart5.language.locale = am4lang_es_ES;
      chart5.language.locale["_decimalSeparator"] = ".";
      chart5.language.locale["_thousandSeparator"] = ",";
      chart5.exporting.menu = new am4core.ExportMenu();
      chart5.exporting.filePrefix = "DemandaElectricaAnualSectorIndustrial";
      chart5.exporting.useWebFonts = false;
      chart5.paddingLeft = 20;
      chart5.paddingRight = 50;
      chart5.fontSize = 12;

      chart5.data = demandaIndustriaDatos;

      // Create axes
      let categoryAxis5 = chart5.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis5.dataFields.category = "a";
      categoryAxis5.renderer.grid.template.location = 0;
      categoryAxis5.renderer.minGridDistance = 10;

      let valueAxis5 = chart5.yAxes.push(new am4charts.ValueAxis());
      //valueAxis5.renderer.inside = true;
      //valueAxis5.renderer.labels.template.disabled = true;
      valueAxis5.title.text = "TWh";
      valueAxis5.min = 0;
      valueAxis5.extraMax = 0.1;
      valueAxis5.calculateTotals = true;

      // Create series
      function createSeries5(field, name, color) {
        
        // Set up series
        let series = chart5.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        
        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
        
        return series;
      }

      for(var i=0; i<demandaIndustriaVariables.length; i++)
      {
        let v = demandaIndustriaVariables[i];
        createSeries5(v.id, v.nombre,v.color);
      }

      var totalSeriesDemandaIndustria = chart5.series.push(new am4charts.ColumnSeries());
      totalSeriesDemandaIndustria.dataFields.valueY = "total";
      totalSeriesDemandaIndustria.dataFields.categoryX = "a";
      totalSeriesDemandaIndustria.stacked = true;
      totalSeriesDemandaIndustria.hiddenInLegend = true;
      totalSeriesDemandaIndustria.columns.template.strokeOpacity = 0;

      var totalBulletDemandaIndustria = totalSeriesDemandaIndustria.bullets.push(new am4charts.LabelBullet());
      totalBulletDemandaIndustria.dy = -10;
      totalBulletDemandaIndustria.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletDemandaIndustria.label.hideOversized = false;
      totalBulletDemandaIndustria.label.fontSize = 10;
      totalBulletDemandaIndustria.label.fill = am4core.color("#333");
      totalBulletDemandaIndustria.label.background.fillOpacity = 0.2;
      totalBulletDemandaIndustria.label.padding(5, 5, 5, 5);

      // Legend
      chart5.legend = new am4charts.Legend();
      chart5.legend.useDefaultMarker = true;
      let marker5 = chart5.legend.markers.template.children.getIndex(0);
      marker5.cornerRadius(12, 12, 12, 12);
      marker5.strokeWidth = 2;
      marker5.strokeOpacity = 1;
      marker5.stroke = am4core.color("#fff");

      this.chart5 = chart5;

      //Gráfica - Integración de la generación y uso final TWh

      let chart = am4core.create(this.$refs.graficaFlujo, am4charts.SankeyDiagram);
      chart.language.locale = am4lang_es_ES;
      chart.language.locale["_decimalSeparator"] = ".";
      chart.language.locale["_thousandSeparator"] = ",";
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = "IntegracionGeneracionUsoFinal";
      chart.exporting.useWebFonts = false;
      chart.dataFields.fromName = "from";
      chart.dataFields.toName = "to";
      chart.dataFields.value = "value";
      chart.dataFields.color = "color";
      chart.paddingLeft = 10;
      chart.paddingBottom = 20;
      chart.paddingRight = 120;

      chart.fontSize = 12;
      
      

      chart.data = [
        { "from": "Importaciones", "to": "Sistema eléctrico", "value": 3.9 },

        { "from": "Vapor", "to": "Sistema eléctrico", "value": 38.02 },
        { "from": "Ciclo combinado", "to": "Sistema eléctrico", "value": 171.81 },
        { "from": "Turbogás", "to": "Sistema eléctrico", "value": 9.08 },
        { "from": "Combustión interna", "to": "Sistema eléctrico", "value": 2.71 },

        { "from": "Carboeléctrica", "to": "Sistema eléctrico", "value": 21.6 },
        { "from": "Hidroeléctrica", "to": "Sistema eléctrico", "value": 23.60 },
        { "from": "Eólica", "to": "Sistema eléctrico", "value": 16.72},
        { "from": "Nucleoeléctrica", "to": "Sistema eléctrico", "value": 10.88 },
        { "from": "Geotermoléctrica", "to": "Sistema eléctrico", "value": 5.06 },
        { "from": "Fotovoltaica", "to": "Sistema eléctrico", "value": 8.39},

        { "from": "Sistema eléctrico", "to": "Autoconsumo", "value": 14.0 },

        { "from": "Sistema eléctrico", "to": "Pérdidas por \ntransmisión y \ndistribución", "value": 54.2 , "color": "#333"},
        { "from": "Sistema eléctrico", "to": "Exportaciones", "value": 5.21 },
        { "from": "Sistema eléctrico", "to": "Comercial", "value": 25.74},
        { "from": "Sistema eléctrico", "to": "Público", "value": 9.15},
        { "from": "Sistema eléctrico", "to": "Agropecuario", "value": 11.5 },
        { "from": "Sistema eléctrico", "to": "Residencial", "value": 64.48 },
        { "from": "Sistema eléctrico", "to": "Transporte", "value": 1.1},
        { "from": "Sistema eléctrico", "to": "Industrial", "value": 170.59 },

        /*{ "from": "Industrial", "to":     "Siderurgia", "value": 5.396388893206 },
        { "from": "Industrial", "to":     "Química", "value": 4.107222225508 },
        { "from": "Industrial", "to":     "Azúcar", "value": 1.0972222231 },
        { "from": "Industrial", "to":     "Petroquímica de PEMEX", "value": 1.636944445754 },
        { "from": "Industrial", "to":     "Cemento", "value": 10.357777786064 },
        { "from": "Industrial", "to":     "Minería", "value": 12.83472223249 },
        { "from": "Industrial", "to":     "Celulosa y papel", "value": 3.41111111384 },
        { "from": "Industrial", "to":     "Vidrio", "value": 1.269166667682 },
        { "from": "Industrial", "to":     "Cerveza y malta", "value": 1.306388889934 },
        { "from": "Industrial", "to":     "Fertilizantes", "value": 0.21527777795 },
        { "from": "Industrial", "to":     "Automotriz", "value": 2.83472222449 },
        { "from": "Industrial", "to":     "Aguas envasadas", "value": 1.086944445314 },
        { "from": "Industrial", "to":     "Construcción", "value": 0.571388889346 },
        { "from": "Industrial", "to":     "Hule", "value": 0.457222222588 },
        { "from": "Industrial", "to":     "Aluminio", "value": 0 },
        { "from": "Industrial", "to":     "Tabaco", "value": 0.080000000064 },
        { "from": "Industrial", "to":     "Otras ramas", "value": 123.935277876926 },*/


      ];

      
      this.chart = chart;

      let chart2 = am4core.create(this.$refs.graficaFlujoConsumo, am4charts.SankeyDiagram);
      chart2.language.locale = am4lang_es_ES;
      chart2.language.locale["_decimalSeparator"] = ".";
      chart2.language.locale["_thousandSeparator"] = ",";
      chart2.exporting.menu = new am4core.ExportMenu();
      chart2.exporting.filePrefix = "UsoFinalElectricidad";
      chart2.exporting.useWebFonts = false;
      chart2.dataFields.fromName = "from";
      chart2.dataFields.toName = "to";
      chart2.dataFields.value = "value";
      chart2.dataFields.color = "color";
      chart2.paddingLeft = 10;
      chart2.paddingRight = 120;

      chart2.fontSize = 12;

      chart2.data = [

        { "from": "Sistema eléctrico", "to": "Autoconsumo", "value": 14.0 },

        { "from": "Sistema eléctrico", "to": "Pérdidas por \ntransmisión y \ndistribución", "value": 54.2 , "color": "#333"},
        { "from": "Sistema eléctrico", "to": "Exportaciones", "value": 5.21 },
        { "from": "Sistema eléctrico", "to": "Comercial", "value": 25.74},
        { "from": "Sistema eléctrico", "to": "Público", "value": 9.15},
        { "from": "Sistema eléctrico", "to": "Agropecuario", "value": 11.5 },
        { "from": "Sistema eléctrico", "to": "Residencial", "value": 64.48 },
        { "from": "Sistema eléctrico", "to": "Transporte", "value": 1.1},
        { "from": "Sistema eléctrico", "to": "Industrial", "value": 170.59 },

        { "from": "Transporte", "to":     "Eléctrico", "value": 1.10 },
        { "from": "Transporte", "to":     "Ferroviario", "value": 0.05 },

        { "from": "Industrial", "to":     "Siderurgia", "value": 5.4 },
        { "from": "Industrial", "to":     "Química", "value": 4.1 },
        { "from": "Industrial", "to":     "Azúcar", "value": 1.1 },
        { "from": "Industrial", "to":     "Petroquímica de PEMEX", "value": 1.64 },
        { "from": "Industrial", "to":     "Cemento", "value": 10.35 },
        { "from": "Industrial", "to":     "Minería", "value": 12.83 },
        { "from": "Industrial", "to":     "Celulosa y papel", "value": 3.4},
        { "from": "Industrial", "to":     "Vidrio", "value": 1.27},
        { "from": "Industrial", "to":     "Cerveza y malta", "value": 1.3 },
        { "from": "Industrial", "to":     "Fertilizantes", "value": 0.21 },
        { "from": "Industrial", "to":     "Automotriz", "value": 2.83},
        { "from": "Industrial", "to":     "Aguas envasadas", "value": 1.1},
        { "from": "Industrial", "to":     "Construcción", "value": 0.57},
        { "from": "Industrial", "to":     "Hule", "value": 0.48 },
        { "from": "Industrial", "to":     "Aluminio", "value": 0 },
        { "from": "Industrial", "to":     "Tabaco", "value": 0.08},
        { "from": "Industrial", "to":     "Otras ramas", "value": 123.93},
      ]
      ;


      this.chart2 = chart2;

  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }

    if (this.chart2) {
      this.chart2.dispose();
    }

    if (this.chart4) {
      this.chart4.dispose();
    }

    if (this.chart5) {
      this.chart5.dispose();
    }

    if (this.chartProd) {
      this.chartProd.dispose();
    }
  },
  data:function(){ return {
    variables: [
      {"id":"cantidad_1","nombre":"Nombre variable 1","color":"#010"},
      {"id":"cantidad_2","nombre":"Nombre variable 2","color":"#e2e"}
    ],
    prodDatos:prodDatos,
    prodVariables:prodVariables,
    demandaDatos: demandaDatos,
    demandaVariables: demandaVariables,
    demandaIndustriaDatos: demandaIndustriaDatos,
    demandaIndustriaVariables: demandaIndustriaVariables,
  }},
  methods:{
    tooltipProduccion(d) {
      return `Producción<br>${d.a}: ${
        this.prodVariables.find(v => v.id === d.key).nombre
      } | <b>${d[d.key].toFixed(2)}</b> (${((d[d.key] / Object.values(d)
        .filter(f => parseFloat(f)).reduce((a,b) => a+b)
      ) * 100).toFixed(2)}%)`
    },
    tooltipDemanda(d) {
      return `Demanda<br>${d.a}: ${
        this.demandaVariables.find(v => v.id === d.key).nombre
      } | <b>${d[d.key].toFixed(2)}</b> (${((d[d.key] / Object.values(d)
        .filter(f => parseFloat(f)).reduce((a,b) => a+b)
      ) * 100).toFixed(2)}%)`
    },
    tooltipDemandaIndustria(d) {
      return `Demanda<br>${d.a}: ${
        this.demandaIndustriaVariables.find(v => v.id === d.key).nombre
      } | <b>${d[d.key].toFixed(2)}</b> (${((d[d.key] / Object.values(d)
        .filter(f => parseFloat(f)).reduce((a,b) => a+b)
      ) * 100).toFixed(2)}%)`
    },
  }
}


const prodDatos = [
  {"Autogeneracion":33.031111137536,"Generacion":0.000000000000,"PIE":79.728888952672,"Publicas":162.807500130246,"Diferencia":0,"Exportacion":6.06111111596,"Importacion":0.436388889238,"a":"2010", 'total':0},
  {"Autogeneracion":32.735833359522,"Generacion":0.000000000000,"PIE":85.195555623712,"Publicas":174.211666806036,"Diferencia":0,"Exportacion":6.181388893834,"Importacion":0.655277778302,"a":"2011", 'total':0},
  {"Autogeneracion":34.154722249546,"Generacion":0.000000000000,"PIE":83.21944451102,"Publicas":179.021666809884,"Diferencia":0,"Exportacion":6.581666671932,"Importacion":2.342222224096,"a":"2012", 'total':0},
  {"Autogeneracion":38.505277808582,"Generacion":0.000000000000,"PIE":85.845555624232,"Publicas":172.767222360436,"Diferencia":0,"Exportacion":7.35555556144,"Importacion":1.650555556876,"a":"2013", 'total':0},
  {"Autogeneracion":43.178055590098,"Generacion":0.000000000000,"PIE":87.596388958966,"Publicas":172.541389026922,"Diferencia":0,"Exportacion":9.403611118634,"Importacion":2.539166668698,"a":"2014", 'total':0},
  {"Autogeneracion":47.874444482744,"Generacion":0.000000000000,"PIE":90.491111183504,"Publicas":171.984166804254,"Diferencia":0,"Exportacion":9.160277785106,"Importacion":2.44305555751,"a":"2015", 'total':0},
  {"Autogeneracion":54.393333376848,"Generacion":0.903888889612,"PIE":90.329444516708,"Publicas":174.71805569533,"Diferencia":0,"Exportacion":8.612222229112,"Importacion":3.461944447214,"a":"2016", 'total':0},
  {"Autogeneracion":66.1358253306864,"Generacion":3.9633005587262,"PIE":87.9277100703422,"Publicas":171.058518747958,"Diferencia":0,"Exportacion":7.87548139518927,"Importacion":2.3318977796433,"a":"2017", 'total':0},
  {"Autogeneracion":75.145833393450,"Generacion":14.244166678062,"PIE":88.736666737656,"Publicas":171.17222235916,"Diferencia":0,"Exportacion":7.403055561478,"Importacion":3.94027778093,"a":"2018", 'total':0},
  {"Autogeneracion":77.480277839762,"Generacion":21.995277795374,"PIE":94.43333340888,"Publicas":150.67083345387,"Diferencia":9.161388896218,"Exportacion":5.211666670836,"Importacion":3.907500003126,"a":"2019", 'total':0},
  
], 
prodVariables = [
  //{"id":"Diferencia","nombre":"Diferencia estadística","color":"#e044a7"},
  {"id":"Importacion","nombre":"Importación","color":"#d9b300"},
  {"id":"Exportacion","nombre":"Exportación","color":"#744ec2"},
  {"id":"Generacion","nombre":"Centrales eléctricas con modalidad de Generación","color":"#12239e"},
  {"id":"Autogeneracion","nombre":"Centrales eléctricas con Autogeneración","color":"#118dff"},
  {"id":"PIE","nombre":"Centrales eléctricas PIE","color":"#e66c37"},
  {"id":"Publicas","nombre":"Centrales eléctricas Públicas","color":"#6b007b"},
  
], 
demandaDatos = [
  {"Agropecuario":8.60138889577,"Comercial":13.139722232734,"ConsumoPropio":12.916666677,"Industrial":132.712222328392,"Perdidas":44.251944479846,"Publico":7.723055561734,"Residencial":49.40694448397,"TE":1.150555556476,"TF":0.040000000032,"a":"2010", 'total':0},
  {"Agropecuario":10.975833342114,"Comercial":13.745000010996,"ConsumoPropio":13.660277788706,"Industrial":140.916944557178,"Perdidas":45.601944480926,"Publico":8.08888889536,"Residencial":52.505000042004,"TE":1.07916666753,"TF":0.043611111146,"a":"2011", 'total':0},
  {"Agropecuario":10.820555564212,"Comercial":14.078333344596,"ConsumoPropio":14.80000001184,"Industrial":146.118611228006,"Perdidas":44.05000003524,"Publico":8.388055562266,"Residencial":52.771111153328,"TE":1.085833334202,"TF":0.04444444448,"a":"2012", 'total':0},
  {"Agropecuario":10.285555563784,"Comercial":13.911388900018,"ConsumoPropio":13.751944455446,"Industrial":147.390000117912,"Perdidas":42.520000034016,"Publico":9.285277785206,"Residencial":53.094166709142,"TE":1.129444445348,"TF":0.044722222258,"a":"2013", 'total':0},
  {"Agropecuario":10.032500008026,"Comercial":18.8750000151,"ConsumoPropio":13.933055566702,"Industrial":147.528055673578,"Perdidas":41.321388921946,"Publico":8.99861111831,"Residencial":54.617500043694,"TE":1.102500000882,"TF":0.042500000034,"a":"2014", 'total':0},
  {"Agropecuario":10.067500008054,"Comercial":21.9583333509,"ConsumoPropio":14.253611122514,"Industrial":149.992222342216,"Perdidas":40.640000032512,"Publico":8.990833340526,"Residencial":56.596388934166,"TE":1.08194444531,"TF":0.05138888893,"a":"2015", 'total':0},
  {"Agropecuario":11.335000009068,"Comercial":23.994722241418,"ConsumoPropio":14.764166678478,"Industrial":155.9444445692,"Perdidas":40.378611143414,"Publico":8.67222222916,"Residencial":58.965555602728,"TE":1.090000000872,"TF":0.05000000004,"a":"2016", 'total':0},
  {"Agropecuario":11.57084834259,"Comercial":22.6360394625533,"ConsumoPropio":12.5639069544956,"Industrial":157.412743181486,"Perdidas":51.096027263099,"Publico":8.0324836175371,"Residencial":59.1528544917667,"TE":1.05428527862121,"TF":0.022582777795844,"a":"2017", 'total':0},
  {"Agropecuario":12.37777778768,"Comercial":24.214722241594,"ConsumoPropio":13.291111121744,"Industrial":168.391389023602,"Perdidas":54.616944488138,"Publico":8.592777784652,"Residencial":63.278333383956,"TE":1.019722223038,"TF":10.053333333376,"a":"2018", 'total':0},
  {"Agropecuario":13.129722232726,"Comercial":25.74305557615,"ConsumoPropio":14.009444455652,"Industrial":170.598055692034,"Perdidas":54.21250004337,"Publico":9.153055562878,"Residencial":64.485555607144,"TE":1.051111111952,"TF":0.054722222266,"a":"2019", 'total':0},
  
], 
demandaVariables = [
  {"id":"TE","nombre":"Transporte eléctrico","color":"#e66c37"},
  {"id":"Publico","nombre":"Público","color":"#12239e"},
  {"id":"Agropecuario","nombre":"Agropecuario","color":"#a38600"}, 
  {"id":"TF","nombre":"Transporte ferroviario","color":"#6b007b"},
  {"id":"ConsumoPropio","nombre":"Consumo propio del sector","color":"#118dff"},
  {"id":"Comercial","nombre":"Comercial","color":"#e8d166"},
  {"id":"Perdidas","nombre":"Pérdidas por transmisión y distribución","color":"#6b2328"},
  {"id":"Residencial","nombre":"Residencial","color":"#cccccc"},
  {"id":"Industrial","nombre":"Industrial","color":"#de6a73"},
  
],
demandaIndustriaDatos = [
  {"AE":0.768333333948,"AUT":1.983055557142,"AZ":0.756111111716,"CEL":2.680277779922,"CEM":8.469722228998,"CER":0.911666667396,"CON":0.459166667034,"FER":0.136388888998,"HUL":0.398888889208,"MIN":7.311666672516,"OR":94.832500075866,"PQ":1.367500001094,"QUI":4.970000003976,"SID":6.064722227074,"TAB":0.061944444494,"VID":1.540555556788,"a":"2010", 'total':0},
  {"AE":0.814166667318,"AUT":2.114166668358,"AZ":0.791944445078,"CEL":2.667500002134,"CEM":8.762222229232,"CER":0.821666667324,"CON":0.477500000382,"FER":0.144166666782,"HUL":0.425555555896,"MIN":7.296388894726,"OR":102.425555637496,"PQ":1.391111112224,"QUI":4.961666670636,"SID":6.050555560396,"TAB":0.064722222274,"VID":1.7083333347,"a":"2011", 'total':0},
  {"AE":0.842500000674,"AUT":2.126111112812,"AZ":0.844166667342,"CEL":2.78750000223,"CEM":9.349722229702,"CER":1.01250000081,"CON":0.49583333373,"FER":0.135277777886,"HUL":0.460833333702,"MIN":8.578888895752,"OR":105.68750008455,"PQ":1.328888889952,"QUI":4.725555559336,"SID":6.485833338522,"TAB":0.066388888942,"VID":1.191388889842,"a":"2012", 'total':0},
  {"AE":0.850833334014,"AUT":2.18750000175,"AZ":1.15138888981,"CEL":2.860000002288,"CEM":10.036944452474,"CER":1.022777778596,"CON":0.492500000394,"FER":0.13194444455,"HUL":0.457777778144,"MIN":10.081666674732,"OR":104.71527786155,"PQ":1.421388890026,"QUI":4.75694444825,"SID":5.995000004796,"TAB":0.067222222276,"VID":1.160555556484,"a":"2013", 'total':0},
  {"AE":0.878611111814,"AUT":2.368611113006,"AZ":0.974722223002,"CEL":2.938333335684,"CEM":9.170277785114,"CER":1.056111111956,"CON":0.511944444854,"FER":0.20138888905,"HUL":0.481666667052,"MIN":9.541388896522,"OR":106.514166751878,"PQ":1.386944445554,"QUI":4.739444448236,"SID":5.51527778219,"TAB":0.0694444445,"VID":1.179722223166,"a":"2014", 'total':0},
  {"AE":0.915555556288,"AUT":2.55833333538,"AZ":0.986666667456,"CEL":3.028055557978,"CEM":9.68611111886,"CER":1.100277778658,"CON":0.51944444486,"FER":0.20555555572,"HUL":0.50555555596,"MIN":10.587222230692,"OR":107.304444530288,"PQ":1.303611112154,"QUI":4.633611114818,"SID":5.339444448716,"TAB":0.07222222228,"VID":1.246388889886,"a":"2015", 'total':0},
  {"AE":1.001944445246,"AUT":2.673055557694,"AZ":1.053611111954,"CEL":3.314444447096,"CEM":10.355277786062,"CER":1.204444445408,"CON":0.555277778222,"FER":0.207777777944,"HUL":0.542500000434,"MIN":11.286388897918,"OR":110.73055564414,"PQ":1.191944445398,"QUI":4.684444448192,"SID":5.730833337918,"TAB":0.07916666673,"VID":1.332500001066,"a":"2016", 'total':0},
  {"AE":1.017476945258,"AUT":2.662932779908,"AZ":1.052071389730,"CEL":3.21563333590,"CEM":10.20311667482,"CER":1.222998889867,"CON":0.55489583377725,"FER":0.207753611277314,"HUL":0.49784305595383,"MIN":11.9856152873663,"OR":111.637293144865,"PQ":1.73978639028072,"QUI":4.38838833684404,"SID":5.68415361565843,"TAB":0.074819722282078,"VID":1.26796388990326,"a":"2017", 'total':0},
  {"AE":1.027500000822,"AUT":2.748888891088,"AZ":1.072777778636,"CEL":3.2916666693,"CEM":10.280277786002,"CER":1.250000001,"CON":0.56250000045,"FER":0.209444444612,"HUL":0.502500000402,"MIN":12.83472223249,"OR":121.784444541872,"PQ":1.593888890164,"QUI":4.310555559004,"SID":5.55277778222,"TAB":0.076944444506,"VID":1.292500001034,"a":"2018", 'total':0},
  {"AE":1.086944445314,"AUT":2.83472222449,"AZ":1.0972222231,"CEL":3.41111111384,"CEM":10.357777786064,"CER":1.306388889934,"CON":0.571388889346,"FER":0.21527777795,"HUL":0.457222222588,"MIN":12.83472223249,"OR":123.935277876926,"PQ":1.636944445754,"QUI":4.107222225508,"SID":5.396388893206,"TAB":0.080000000064,"VID":1.269166667682,"a":"2019", 'total':0},
  
], 
demandaIndustriaVariables = [
  {"id":"FER","nombre":"Fertilizantes","color":"#744ec2"},
  {"id":"CON","nombre":"Construcción","color":"#e044a7"},
  {"id":"HUL","nombre":"Hule","color":"#d9b300"},
  {"id":"AE","nombre":"Aguas envasadas","color":"#12239e"},
  {"id":"AZ","nombre":"Azúcar","color":"#118dff"},
  {"id":"CER","nombre":"Cerveza y malta","color":"#e044a7"},
  {"id":"PQ","nombre":"Petroquímica de PEMEX","color":"#197278"},
  {"id":"TAB","nombre":"Tabaco","color":"#4092ff"},
  {"id":"VID","nombre":"Vidrio","color":"#ffa058"},
  {"id":"CEL","nombre":"Celulsa y papel","color":"#12239e"},
  {"id":"AUT","nombre":"Automotriz","color":"#a1343c"},
  {"id":"QUI","nombre":"Química","color":"#1aab40"},
  {"id":"SID","nombre":"Siderurgia","color":"#15c6f4"},
  {"id":"CEM","nombre":"Cemento","color":"#6b007b"},
  {"id":"MIN","nombre":"Minería","color":"#d64550"},
  {"id":"OR","nombre":"Otras ramas","color":"#999999"},
]

</script>

<style lang="scss">
  .tooltip
  {
    background-color: #FFF !important;
  }

  .graficaFlujo {
    
    width: 100%;
    height: 600px;
  }

  .graficaFlujoConsumo {
    
    width: 100%;
    height: 600px;
  }

  .barrasProd
  {
    width: 100%;
    height: 500px;
  }

  .barrasDamandaElectrica
  {
    width: 100%;
    height: 500px;
  }

  .barrasIndustria
  {
    width: 100%;
    height: 500px;
  }
</style>
